import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ERROR_ACTION, WAIT_FOR_ACTION } from 'redux-wait-for-action';
import { ConstantsUtil } from '@utils';
import { CLOSE_SNACKBAR, CLOSING_SNACKBAR_WITH_ANSWER, INIT_CLOSE_SNACKBAR, INIT_SNACKBAR_CLOSING_WITH_ANSWER, SET_SNACKBAR, SNACKBAR_INIT } from './snackbars.action-types';
export var actions = {
  /**
   * Init snackbar closing.
   *
   * @author Mikhail Siutsou
   * @function snackbarInitClosing
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarClosePayload} payload payload.
   */
  snackbarInitClosing: function snackbarInitClosing(payload) {
    return {
      type: INIT_CLOSE_SNACKBAR,
      payload: payload
    };
  },

  /**
   * Close snackbar.
   *
   * @author Mikhail Siutsou
   * @function snackbarClose
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarClosePayload} payload payload.
   */
  snackbarClose: function snackbarClose(payload) {
    return {
      type: CLOSE_SNACKBAR,
      payload: payload
    };
  },

  /**
   * Init snackbar opening.
   *
   * @author Mikhail Siutsou
   * @function snackbarInit
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarPayload} payload payload.
   */
  snackbarInit: function snackbarInit(payload) {
    var _ref;

    return _ref = {
      type: SNACKBAR_INIT,
      payload: payload
    }, _defineProperty(_ref, WAIT_FOR_ACTION, "".concat(SNACKBAR_INIT, "/").concat(ConstantsUtil.actions.ASYNC_SUCCESS)), _defineProperty(_ref, ERROR_ACTION, "".concat(SNACKBAR_INIT, "/").concat(ConstantsUtil.actions.ASYNC_FAILED)), _ref;
  },

  /**
   * Set necessary snackbar.
   *
   * @author Mikhail Siutsou
   * @function setSnackbar
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarPayload} payload payload.
   */
  setSnackbar: function setSnackbar(payload) {
    return {
      type: SET_SNACKBAR,
      payload: payload
    };
  },

  /**
   * Init closing with answer.
   *
   * @author Mikhail Siutsou
   * @function snackbarInitClosingWithAnswer
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarCloseWithAnswerPayload} payload payload.
   */
  snackbarInitClosingWithAnswer: function snackbarInitClosingWithAnswer(payload) {
    return {
      type: INIT_SNACKBAR_CLOSING_WITH_ANSWER,
      payload: payload
    };
  },

  /**
   * Close snackbar with answer.
   *
   * @author Mikhail Siutsou
   * @function closeWithAnswer
   * @category Actions
   * @subcategory Snackbars
   * @param {SnackbarCloseWithAnswerPayload} payload payload.
   */
  closeWithAnswer: function closeWithAnswer(payload) {
    return {
      type: CLOSING_SNACKBAR_WITH_ANSWER,
      payload: payload
    };
  }
};